var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kd-layers",class:{
    'kd-layers--dimmed': _vm.LAYOUT_MODE_ACTIVE,
  }},_vm._l((_vm.ACTIVE_SIDE.layers),function(layer){return _c('kd-layer',{key:layer.id,staticClass:"kd-card__layer",attrs:{"layer":layer}},[_vm._v("\n  >")])}))}
var staticRenderFns = []

export { render, staticRenderFns }